/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const PACKAGE_UPDATE_STATUS_LABEL_OVERRIDES: Record<string, string> = {
  installedPendingReboot: "pendingReboot",
};
